module.exports = __webpack_public_path__ + "img/favorite.4ef05b82.svg";